// Chakra v3 has changed the styling system significantly
// We'll provide a compatibility layer for useStyleConfig
import { useMemo } from "react";

export type ThemingProps = {
  variant?: string;
  size?: string;
  colorPalette?: string;
};

export type SystemStyleObject = Record<string, unknown>;

export const useStyleConfig = (
  themeKey: string,
  props?: ThemingProps & Record<string, unknown>
): SystemStyleObject => {
  const { variant, size, colorPalette, ...rest } = props || {};

  // In v3, we can't directly use useStyleConfig the same way
  // For now, return an empty object or the passed props
  // Individual components will handle their own styling
  const styles = useMemo(() => {
    return {
      ...rest,
      variant,
      size,
      colorPalette,
    };
  }, [variant, size, colorPalette, rest]);

  return styles as SystemStyleObject;
};

export default useStyleConfig;
